import { INSERT_ORDER_REQUEST, INSERT_ORDER_SUCCESS, INSERT_ORDER_FAILURE } from "./paymentType";



export const insertOrderRequest = (orderData) => ({
    type: INSERT_ORDER_REQUEST,
    payload: orderData,
});

export const insertOrderSuccess = (response) => ({
    type: INSERT_ORDER_SUCCESS,
    payload: response,
});

export const insertOrderFailure = (error) => ({
    type: INSERT_ORDER_FAILURE,
    payload: error,
});